import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationKey } from '../../i18n/translationKeys';
import { ModalShell } from '../../ui/ModalShell/ModalShell';
import { TextArea } from '../../ui/TextArea/TextArea';
import { Button } from '../../ui/Button/Button';

interface ReactivateRelanceModalProps {
    onConfirm: (reason: string | null) => void;
    onCancel: () => void;
}

export const ReactivateRelanceModal: React.FC<ReactivateRelanceModalProps> = ({ onConfirm, onCancel }) => {
    const { t } = useTranslation();
    const [reason, setReason] = useState('');

    const handleConfirm = () => {
        const trimmed = reason.trim();
        onConfirm(trimmed.length > 0 ? trimmed : null);
    };

    return (
        <ModalShell
            heading={t(TranslationKey.Home.ReactivateModal.Heading)}
            onClose={onCancel}
            dismissAriaLabel={t(TranslationKey.Home.ReactivateModal.Cancel)}
            rootTestId="reactivate-relance-modal"
            footer={
                <>
                    <Button variant="secondary" type="button" onClick={onCancel} data-testid="reactivate-relance-cancel">
                        {t(TranslationKey.Home.ReactivateModal.Cancel)}
                    </Button>
                    <Button type="button" onClick={handleConfirm} data-testid="reactivate-relance-confirm">
                        {t(TranslationKey.Home.ReactivateModal.Reactivate)}
                    </Button>
                </>
            }
        >
            <TextArea
                id="reactivate-relance-reason"
                label={t(TranslationKey.Home.ReactivateModal.ReasonLabel)}
                placeholder={t(TranslationKey.Home.ReactivateModal.ReasonPlaceholder)}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                rows={3}
                data-testid="reactivate-relance-reason-input"
            />
        </ModalShell>
    );
};
